// Helper function to generate valid MongoDB ObjectID-like strings
export const generateValidId = () => {
  return Array(24).fill(0).map(() => 
    Math.floor(Math.random() * 16).toString(16)
  ).join('');
}; 